<template>
	<div class="left-menu">
		<el-menu :default-active="activeindex" :router="true" :unique-opened="true">
			<template v-for="(role, index) in rolemenu">
				<el-submenu :key="role.id" :index="index.toString()" v-if="role.child && role.child.length">
					<template slot="title">
						<i :class="role.class"></i>
						<span>{{role.menuName}}</span>
					</template>
					<el-menu-item v-for="item in role.child" v-bind:key="item.id" v-bind:index="item.menuUrl" style="padding-left:50px">{{item.menuName}}
					</el-menu-item>
				</el-submenu>
				<el-menu-item v-else :key="role.id" :index="role.menuUrl" class="el-submenu__title">
					<i :class="role.class"></i>
					<span>{{role.menuName}}</span>
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>
<script>
	import {getStore} from "../utils/utils";

	const menuico = { 11: 'el-icon-message', 16: 'el-icon-notebook-1', 22: 'el-icon-video-camera', 24: 'el-icon-user', 26: 'el-icon-setting' ,29:'el-icon-menu',31:'el-icon-pie-chart', 39: 'el-icon-share',42:'el-icon-document'}
	export default {
		data() {
			return {
				activeindex: '/caseInHand',
				rolemenu: [],
				menuList: [
					{ id: 24, parentId: 0, menuName: "我的案件", menuUrl: null, class:'el-icon-video-camera', child: [
							{ id: 25, parentId: 24, menuName: "正在审理", menuUrl: "/caseInHand"},
							{ id: 26, parentId: 24, menuName: "已结案件", menuUrl: "/caseClosed" },
						]},
					{ id: 27, parentId: 0, menuName: "人员管理", class:'el-icon-user',  menuUrl: "/personManage" },
					{ id: 29, parentId: 0, menuName: "案件监管", class:'el-icon-document',  menuUrl: "/caseSupervision" }
				],
				hasNoRead: false,
			}
		},
		watch: {
			'$route'() {
				this.updateIndex()
			}
		},
		created() {
			let loginInfo = JSON.parse(getStore('loginInfo_worker'))
			if (loginInfo.userRoles && loginInfo.userRoles.length) {
				let staffRole = loginInfo.userRoles.filter(item => {return item.roleCode == 'MEDIATOR' || item.roleCode == 'CLERK'})
				let manageRole = loginInfo.userRoles.filter(item => {return item.roleCode == 'MANAGE'})
				if (staffRole && staffRole.length) {
					this.rolemenu.push(this.menuList[0])
				}
				if (manageRole && manageRole.length) {
					this.rolemenu.push(this.menuList[1])
					this.rolemenu.push(this.menuList[2])
				}
			}
		},
		mounted() {
			this.updateIndex()
		},
		methods: {
			updateIndex() {
				this.rolemenu.forEach(role => {
					if (role.child && role.child.length) {
						role.child.forEach(item => {
							if ((this.$route.path).indexOf(item.menuUrl) >= 0) {
								this.activeindex = item.menuUrl
							}
						});
					} else {
						if ((this.$route.path).indexOf(role.menuUrl) >= 0) {
							this.activeindex = role.menuUrl
						}
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.left-menu {
		width: 200px;
		background-color: #fff;
		.red-circle {
			position: absolute;
			top: -6px;
			right: 50px;
		}
		.el-menu {
			border-right: none;
			.el-menu-item {
				display: flex;
				align-items: center;
			}
			.el-menu-item.is-active {
				color: #fff !important;;
				i {
					color: #fff !important;;
				}
				background-color: #0083c8 !important;
			}
			.el-submenu__title {
				font-size: 16px;
				padding-left:20px;
				color: #000;
				background-color: #ffffff;
			}
			.el-submenu__title:hover {
				background-color: #ffffff;
				color: #0083c8;
				i {
					color: #0083c8;
				}
			}
			.el-submenu {
				border-bottom: 1px solid #eee;
				.el-menu-item {
					padding: 0 20px 0 50px;
					line-height: 48px;
					height: 48px;
					color: #444;
				}
				.el-menu-item:hover {
					background-color: #ffffff;
					color: #0083c8;
					i {
						color: #0083c8;
					}
				}
			}
		}
	}
</style>
